import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <>
    <section className="relative w-full bg-primary-900 pt-[120px] pb-16 md:pb-20">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(212,175,55,0.06),transparent_60%)]"></div>

      <div className="relative max-w-[800px] mx-auto px-8 text-center">
        <h1 className="font-heading text-2xl md:text-3xl text-foreground-50 tracking-[0.08em] mb-4">
          {t('privacy.hero.title')}
        </h1>
        <p className="text-accent-400 text-[15px] md:text-[17px] tracking-[0.12em] mb-6 font-label">
          {t('privacy.hero.titleEn')}
        </p>
        <div className="flex items-center justify-center gap-3 mb-0">
          <span className="block w-8 h-[1px] bg-accent-500/40"></span>
          <span className="block w-12 h-[1px] bg-accent-500/60"></span>
          <span className="block w-8 h-[1px] bg-accent-500/40"></span>
        </div>
      </div>
    </section>
    <nav aria-label="パンくずリスト" className="bg-background-50 border-b border-background-200"><div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16 py-3 flex items-center gap-2 text-[13px] text-foreground-500"><Link to="/" className="hover:text-accent-600 transition-colors">{t('privacy.hero.homeLink')}</Link><i className="ri-arrow-right-s-line text-foreground-400 text-[12px]"></i><span className="text-foreground-700">{t('privacy.hero.currentPage')}</span></div></nav>
    </>
  );
}